<ngx-loading-bar [color]="'var(--bulud-primary)'" height="7px"></ngx-loading-bar>
<router-outlet></router-outlet>

